import { render } from "./j-tab-panel.vue?vue&type=template&id=7f5c47ff&scoped=true"
import script from "./j-tab-panel.vue?vue&type=script&lang=js"
export * from "./j-tab-panel.vue?vue&type=script&lang=js"

import "./j-tab-panel.vue?vue&type=style&index=0&id=7f5c47ff&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5c47ff"]])

export default __exports__